import { request } from '@/utils/request'

export function getMenu(params) {
  return request({
    url: '/permissions/menu',
    method: 'get',
    params
  })
}
/**
 * 通过企业id、项目id获取菜单列表
 * @param {*} data 
 * @returns 
 */
export function getMenuV2(data) {
  return request({
    url: '/permissions/menu/v2',
    method: 'post',
    data
  })
}
// 获取所有权限码
export function getPermCode(params) {
  return request({
    url: '/permissions/all-code',
    method: 'get',
    params
  })
}
